import { env } from "@/env";

// The platform/tenant this Admin instance represents. White-label deploys map
// their host → platform id via `VITE_DOMAIN_PLATFORM_MAP`; everything else falls
// back to the default Tournated platform id. This is the `platformId` the ID
// portal needs to brand the login screen and (optionally) gate access.
export const resolvePlatformId = (): string => {
  const host = typeof window !== "undefined" ? window.location.host : "";
  return env.domainPlatformMap[host] ?? String(env.tournatedPlatformId);
};
